require('./angular-locale_fr');
module.exports = 'ngLocale';



// WEBPACK FOOTER //
// ./node_modules/angular-i18n/fr.js